export const MANAGEMENTS_ENVIRONMENT_LIGHT = 2;
export const MANAGEMENTS_ENVIRONMENT_GAS = 3;

export const MANAGEMENTS_SUBTYPE_UPDATE_POWERS = 56;
export const MANAGEMENTS_SUBTYPE_UPDATE_GAS_FLOW = 64;
export const MANAGEMENTS_SUBTYPE_DOMICILIATION_LIGHT = 58;
export const MANAGEMENTS_SUBTYPE_DOMICILIATION_GAS = 66;
export const MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS = 59;

export const MANAGEMENTS_SUBTYPE_OWNERSHIP_LIGHT = 55;
export const MANAGEMENTS_SUBTYPE_OWNERSHIP_GAS = 63;

export const MANAGEMENTS_SUBTYPE_CONTRACT_END_LIGHT = 57;
export const MANAGEMENTS_SUBTYPE_CONTRACT_END_GAS = 65;

export const SERVICES_ENVIRONMENT_LIGHT = "8";
export const SERVICES_ENVIRONMENT_GAS = "7";

export const SERVICES_SUBTYPE_COVERAGES = 248;
export const SERVICES_SUBTYPE_BILLS = 246;
export const SERVICES_SUBTYPE_POWERS = 243;
export const SERVICES_SUBTYPE_GAS_FLOW = 244;

// TODO: CAMBIAR!
export const MANAGEMENTS_SUBTYPE_UPDATE_HOLDER = 1;
export const MANAGEMENTS_SUBTYPE_CONTRACT_END = 3;
export const MANAGEMENTS_SUBTYPE_CLAIMS = 4;

export const MANAGEMENTS_SUBTYPE_UPDATE_POWERS_TEXT = "Cambio de Potencia";
export const MANAGEMENTS_SUBTYPE_UPDATE_GAS_FLOW_TEXT =
  "Cambio de Peaje y/o Caudal";
export const MANAGEMENTS_SUBTYPE_UPDATE_HOLDER_TEXT = "Cambio de Titular";
export const MANAGEMENTS_SUBTYPE_UPDATE_BANK_ACCOUNT_TEXT =
  "Cambio Número de Cuenta - SEPA";
export const MANAGEMENTS_SUBTYPE_UPDATE_CONTACT_TEXT =
  "Actualización Datos Contacto";
export const MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT =
  "Actualización Dirección de Correspondencia";
export const MANAGEMENTS_SUBTYPE_UPDATE_CLAIM_TEXT = "Reclamación";
export const MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT =
  "Baja por Cese de Actividad";

// export const MANAGEMENT_TYPES = [
//   {
//     id: MANAGEMENTS_SUBTYPE_UPDATE_POWERS,
//     name: MANAGEMENTS_SUBTYPE_UPDATE_POWERS_TEXT,
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_UPDATE_GAS_FLOW,
//     name: MANAGEMENTS_SUBTYPE_UPDATE_GAS_FLOW_TEXT,
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_DOMICILIATION_LIGHT,
//     text: MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_DOMICILIATION_GAS,
//     text: MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS,
//     text: MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_OWNERSHIP_LIGHT,
//     name: MANAGEMENTS_SUBTYPE_UPDATE_HOLDER_TEXT,
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_OWNERSHIP_GAS,
//     name: MANAGEMENTS_SUBTYPE_UPDATE_HOLDER_TEXT,
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_CONTRACT_END_LIGHT,
//     name: MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_CONTRACT_END_GAS,
//     name: MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_UPDATE_BANK_ACCOUNT_TEXT,
//     name: "Cambio de domiciliación bancaria",
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_UPDATE_CONTACT_TEXT,
//     name: "Actualizar datos de contacto",
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT,
//     name: "Actualizar dirección de correspondencia",
//   },
//   {
//     id: MANAGEMENTS_SUBTYPE_UPDATE_CLAIM_TEXT,
//     name: "Reclamaciones",
//   },

// ];

export const MANAGEMENTS_INCIDENCE_TEXT_UPDATE_CONTACT =
  "Agregado nuevo contacto";

export const MANAGEMENTS_INCIDENCE_TEXT_UPDATE_DELIVERY_DATA =
  "Modificación de datos de envío";

export const SERVICES_SUBTYPE_OPTIMIZE_POWER =
  "Asesoría Optimización de Potencias";
export const SERVICES_SUBTYPE_OPTIMIZE_GAS = "Asesoría Optimización de Caudal";
export const SERVICES_SUBTYPE_OPTIMIZE_MARKET = "Informes de Mercado";
export const SERVICES_SUBTYPE_OPTIMIZE_COVERAGES = "Solicitud de Coberturas";
export const SERVICES_SUBTYPE_OPTIMIZE_BILLS = "Simulación de Facturas";

export const MANAGEMENTS_STATE_PENDING = "En curso";
export const MANAGEMENTS_STATE_PENDING_DISTRIBUTION = "Pendiente Distribuidora";
export const MANAGEMENTS_STATE_PENDING_COMMERCIAL = "Pendiente Comercial";
export const MANAGEMENTS_STATE_PENDING_CLIENT = "Pendiente Respuesta Cliente";
export const MANAGEMENTS_STATE_OPEN = "Abierta";
export const MANAGEMENTS_STATE_RESOLVED = "Resuelta";
export const MANAGEMENTS_STATE_UNSOLVED = "Finalizado sin resolver";
export const MANAGEMENTS_STATE_REJECTED = "Rechazada";
export const MANAGEMENTS_STATE_ERROR = "error";

export const MANAGEMENTS_REGISTER_TYPE_CLAIMS = "Reclamación";
export const MANAGEMENTS_REGISTER_TYPE_REQUEST = "Petición";

export const CIF_CUPS_BLOCKS_PER_LOAD = 50;

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 15];

export const RECIPIENT_IDS = [
  { idTipoRegistro: 2, idSubtipoReclamacion: 56, idUsuarioDestino: 3956 }, // Modificación de potencias - Electricidad
  { idTipoRegistro: 3, idSubtipoReclamacion: 64, idUsuarioDestino: 3959 }, // Modificación de caudal diario - Gas
  { idTipoRegistro: 2, idSubtipoReclamacion: 55, idUsuarioDestino: 3957 }, // Cambio de titular - Electricidad
  { idTipoRegistro: 3, idSubtipoReclamacion: 63, idUsuarioDestino: 3958 }, // Cambio de titular - Gas
  { idTipoRegistro: 2, idSubtipoReclamacion: 58, idUsuarioDestino: 1610 }, // Cambio de domiciliación bancaria - Electricidad
  { idTipoRegistro: 3, idSubtipoReclamacion: 66, idUsuarioDestino: 4648 }, // Cambio de domiciliación bancaria - Gas
  { idTipoRegistro: 2, idSubtipoReclamacion: 213, idUsuarioDestino: 3528 }, // Actualizar datos de contacto / Actualizar datos de correspondencia - Electricidad
  { idTipoRegistro: 3, idSubtipoReclamacion: 214, idUsuarioDestino: 3529 }, // Actualizar datos de contacto / Actualizar datos de correspondencia - Gas
  { idTipoRegistro: 1, idSubtipoReclamacion: 8, idUsuarioDestino: 1610 }, // Reclamaciones - Electricidad
  { idTipoRegistro: 1, idSubtipoReclamacion: 10, idUsuarioDestino: 1610 }, // Reclamaciones - Electricidad
  { idTipoRegistro: 1, idSubtipoReclamacion: 9, idUsuarioDestino: 4128 }, // Reclamaciones - Electricidad
  { idTipoRegistro: 1, idSubtipoReclamacion: 1, idUsuarioDestino: 1610 }, // Reclamaciones - Electricidad
  { idTipoRegistro: 1, idSubtipoReclamacion: 16, idUsuarioDestino: 4128 }, // Reclamaciones - Electricidad
  { idTipoRegistro: 4, idSubtipoReclamacion: 33, idUsuarioDestino: 1611 }, // Reclamaciones - Gas
  { idTipoRegistro: 4, idSubtipoReclamacion: 35, idUsuarioDestino: 1611 }, // Reclamaciones - Gas
  { idTipoRegistro: 4, idSubtipoReclamacion: 34, idUsuarioDestino: 4129 }, // Reclamaciones - Gas
  { idTipoRegistro: 4, idSubtipoReclamacion: 31, idUsuarioDestino: 1611 }, // Reclamaciones - Gas
  { idTipoRegistro: 4, idSubtipoReclamacion: 40, idUsuarioDestino: 4129 }, // Reclamaciones - Gas
  { idTipoRegistro: 2, idSubtipoReclamacion: 57, idUsuarioDestino: 4128 }, // Baja por cese de actividad - Electricidad
  { idTipoRegistro: 3, idSubtipoReclamacion: 65, idUsuarioDestino: 4129 }, // Baja por cese de actividad - Gas
  { idTipoRegistro: 8, idSubtipoReclamacion: 250, idUsuarioDestino: 4649 }, // Optimizador de potencias - Electricidad
  { idTipoRegistro: 7, idSubtipoReclamacion: 255, idUsuarioDestino: 4650 }, // Optimizador de caudal - Gas
  { idTipoRegistro: 8, idSubtipoReclamacion: 253, idUsuarioDestino: 4649 }, // Simulador de facturas - Electricidad
  { idTipoRegistro: 7, idSubtipoReclamacion: 258, idUsuarioDestino: 4650 }, // Simulador de facturas - Gas
];

export const RECIPIENT_IDS_TPI = [
  { idTipoRegistro: 2, idSubtipoReclamacion: 58, idUsuarioDestino: 4647 }, // TPI Cambio de domiciliación bancaria - Electricidad
  { idTipoRegistro: 3, idSubtipoReclamacion: 66, idUsuarioDestino: 1611 }, // TPI Cambio de domiciliación bancaria - Gas
];

export const RECIPIENT_IDS_LABEL = [
  {
    idTipoRegistro: 2,
    idSubtipoReclamacion: 56,
    idUsuarioDestino: 3956,
    label: "Modificacion de potencias",
    icon: "t-icon-electricite-big",
  }, // Modificación de potencias - Electricidad
  {
    idTipoRegistro: 3,
    idSubtipoReclamacion: 64,
    idUsuarioDestino: 3959,
    label: "Modificación de caudal diario (Qd)",
    icon: "t-icon-gaz-big",
  }, // Modificación de caudal diario - Gas
  {
    idTipoRegistro: 2,
    idSubtipoReclamacion: 55,
    idUsuarioDestino: 3957,
    label: "Cambio de titular",
    icon: "t-icon-building",
  }, // Cambio de titular - Electricidad
  {
    idTipoRegistro: 3,
    idSubtipoReclamacion: 63,
    idUsuarioDestino: 3958,
    label: "Cambio de titular",
    icon: "t-icon-building",
  }, // Cambio de titular - Gas
  {
    idTipoRegistro: 2,
    idSubtipoReclamacion: 58,
    idUsuarioDestino: 1610,
    label: "Cambio de domiciliación bancaria",
    icon: "t-icon-Bank",
  }, // Cambio de domiciliación bancaria - Electricidad
  {
    idTipoRegistro: 3,
    idSubtipoReclamacion: 66,
    idUsuarioDestino: 4648,
    label: "Cambio de domiciliación bancaria",
    icon: "t-icon-Bank",
  }, // Cambio de domiciliación bancaria - Gas
  {
    idTipoRegistro: 2,
    idSubtipoReclamacion: 213,
    idUsuarioDestino: 3528,
    label: "Actualizar dirección de correspondencia",
    icon: "t-icon-home",
  }, // Actualizar datos de contacto / Actualizar datos de correspondencia - Electricidad
  {
    idTipoRegistro: 3,
    idSubtipoReclamacion: 214,
    idUsuarioDestino: 3529,
    label: "Actualizar dirección de correspondencia",
    icon: "t-icon-home",
  }, // Actualizar datos de contacto / Actualizar datos de correspondencia - Gas
  {
    idTipoRegistro: 1,
    idSubtipoReclamacion: 8,
    idUsuarioDestino: 1610,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Electricidad
  {
    idTipoRegistro: 1,
    idSubtipoReclamacion: 10,
    idUsuarioDestino: 1610,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Electricidad
  {
    idTipoRegistro: 1,
    idSubtipoReclamacion: 9,
    idUsuarioDestino: 4128,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Electricidad
  {
    idTipoRegistro: 1,
    idSubtipoReclamacion: 1,
    idUsuarioDestino: 1610,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Electricidad
  {
    idTipoRegistro: 1,
    idSubtipoReclamacion: 16,
    idUsuarioDestino: 4128,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Electricidad
  {
    idTipoRegistro: 4,
    idSubtipoReclamacion: 33,
    idUsuarioDestino: 1611,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Gas
  {
    idTipoRegistro: 4,
    idSubtipoReclamacion: 35,
    idUsuarioDestino: 1611,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Gas
  {
    idTipoRegistro: 4,
    idSubtipoReclamacion: 34,
    idUsuarioDestino: 4129,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Gas
  {
    idTipoRegistro: 4,
    idSubtipoReclamacion: 31,
    idUsuarioDestino: 1611,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Gas
  {
    idTipoRegistro: 4,
    idSubtipoReclamacion: 40,
    idUsuarioDestino: 4129,
    label: "Reclamación",
    icon: "t-icon-warning",
  }, // Reclamaciones - Gas
  {
    idTipoRegistro: 2,
    idSubtipoReclamacion: 57,
    idUsuarioDestino: 4128,
    label: "Baja por cese de actividad",
    icon: "t-icon-power-off",
  }, // Baja por cese de actividad - Electricidad
  {
    idTipoRegistro: 3,
    idSubtipoReclamacion: 65,
    idUsuarioDestino: 4129,
    label: "Baja por cese de actividad",
    icon: "t-icon-power-off",
  }, // Baja por cese de actividad - Gas
  {
    idTipoRegistro: 8,
    idSubtipoReclamacion: 250,
    idUsuarioDestino: 4649,
    label: "Optimizador de potencias",
    icon: "t-icon-warning",
  }, // Optimizador de potencias - Electricidad
  {
    idTipoRegistro: 7,
    idSubtipoReclamacion: 255,
    idUsuarioDestino: 4650,
    label: "Optimizador de caudal",
    icon: "t-icon-warning",
  }, // Optimizador de caudal - Gas
  {
    idTipoRegistro: 8,
    idSubtipoReclamacion: 253,
    idUsuarioDestino: 4649,
    label: "Simulador de facturas",
    icon: "t-icon-warning",
  }, // Simulador de facturas - Electricidad
  {
    idTipoRegistro: 7,
    idSubtipoReclamacion: 258,
    idUsuarioDestino: 4650,
    label: "Simulador de facturas",
    icon: "t-icon-warning",
  }, // Simulador de facturas - Gas
  //TPI
  // {
  //   idTipoRegistro: 2,
  //   idSubtipoReclamacion: 58,
  //   idUsuarioDestino: 4647,
  //   label: "Cambio de domiciliación bancaria",
  //   icon: "t-icon-Bank",
  // }, // TPI Cambio de domiciliación bancaria - Electricidad
  // {
  //   idTipoRegistro: 3,
  //   idSubtipoReclamacion: 66,
  //   idUsuarioDestino: 1611,
  //   label: "Cambio de domiciliación bancaria",
  //   icon: "t-icon-Bank",
  // }, // TPI Cambio de domiciliación bancaria - Gas
];

export const TARIFF_OPTIONS = {
  electricity: [
    "2.0TD ML",
    "3.0TD ML",
    "3.0TDVE ML",
    "6.2TD ML",
    "6.1TD ML",
    "6.1TDVE ML",
    "6.3TD ML",
    "6.4TD ML",
  ],
  gas: [
    "RL. 1",
    "RL. 2",
    "RL. 3",
    "RL. 4",
    "RL. 5",
    "RL. 6",
    "RL. 7",
    "RL. 8",
    "RL. 9",
    "RL. 10",
  ],
};

// --- Entity Selector Constants ---
export const DATE_FORMATS = {
  LONG_DATE: "DD/MM/YYYY",
  SHORT_DATE: "DD/MM/YY",
  FULL_DATE_TIME: "DD/MM/YYYY HH:mm:ss",
  TIME_ONLY: "HH:mm:ss",
};

export const MAX_ENTITY_SELECTION_DAYS = 1;
